import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { RackListPageRBAC } from 'features/Rack/pages/RackList/rbac'
import { RackDetailPageRBAC } from 'features/Rack/pages/RackDetail/rbac'
import { RackAddEditPageRBAC } from 'features/Rack/pages/RackAddEdit/rbac'
import { RackSingleEditPageRBAC } from 'features/Rack/pages/RackSingleEdit/rbac'
import { AreaListPageRBAC } from '../pages/AreaList/rbac'

const RackList = lazy(() => import('../pages/RackList'))
const RackDetail = lazy(() => import('../pages/RackDetail'))
const RackAddEdit = lazy(() => import('../pages/RackAddEdit'))
const RackSingleEdit = lazy(() => import('../pages/RackSingleEdit'))

const AreaList = lazy(() => import('../pages/AreaList'))

export const RackListRouter: RouterFeatureInterface<'RackListRouter', '/dashboard/rack'> = {
  name: 'RackListRouter',
  Component: RackList,
  path: '/dashboard/rack',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: RackListPageRBAC.pageID,
  isDashboard: true,
}

export const RackDetailRouter: RouterFeatureInterface<
  'RackDetailRouter',
  '/dashboard/rack/detail/:locationId'
> = {
  name: 'RackDetailRouter',
  Component: RackDetail,
  path: '/dashboard/rack/detail/:locationId',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: RackDetailPageRBAC.pageID,
  isDashboard: true,
}

export const RackAddRouter: RouterFeatureInterface<'RackAddRouter', '/dashboard/rack/add'> = {
  name: 'RackAddRouter',
  Component: RackAddEdit,
  path: '/dashboard/rack/add',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: RackAddEditPageRBAC.pageID,
  isDashboard: true,
}

export const RackEditRouter: RouterFeatureInterface<'RackEditRouter', '/dashboard/rack/edit/:id'> =
  {
    name: 'RackEditRouter',
    Component: RackAddEdit,
    path: '/dashboard/rack/edit/:id',
    routeType: 'PRIVATE',
    allowedRoles: [],
    rbacPageID: RackAddEditPageRBAC.pageID,
    isDashboard: true,
  }

export const RackSingleEditRouter: RouterFeatureInterface<
  'RackSingleEditRouter',
  '/dashboard/rack/:locationId/edit/:rackId'
> = {
  name: 'RackSingleEditRouter',
  Component: RackSingleEdit,
  path: '/dashboard/rack/:locationId/edit/:rackId',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: RackSingleEditPageRBAC.pageID,
  isDashboard: true,
}

export const AreaListRouter: RouterFeatureInterface<'AreaListRouter', '/dashboard/area'> = {
  name: 'AreaListRouter',
  Component: AreaList,
  path: '/dashboard/area',
  routeType: 'PRIVATE',
  rbacPageID: AreaListPageRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

const RackRouter = [
  RackListRouter,
  RackDetailRouter,
  RackAddRouter,
  RackEditRouter,
  RackSingleEditRouter,
  AreaListRouter,
]

export const RackRouterDetail = generateRouterDetail(RackRouter)

export default RackRouter
